import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import '../public/assets/css/main.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import Demo from './Demo';
import UploadFiles from './pages/UploadFiles';

const router = createBrowserRouter([
  {
    path: "/",
    // element: <div>Hello world!</div>,
    // Component: App
    Component: UploadFiles

  },
  {
    path: "/demo",
    // element: <div>Hello world!</div>,
    Component: Demo
  },
  {
    path:"/upload",
    Component: UploadFiles
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
        <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
